import React from 'react';
import { FormattedMessage } from 'react-intl';
import gridStyle from './grid-style.module.less';
import messages from './messages';
import classnames from 'classnames';
import style from './style.module.less';

const GridHeader = () => {
  return (
    <div className={gridStyle['grid-header']}>
      <div className={gridStyle['header-item']}>
        <FormattedMessage {...messages.name} />
      </div>
      <div className={gridStyle['header-item']}>
        <FormattedMessage {...messages.description} />
      </div>
      <div className={classnames(gridStyle['header-item'], style['last-modified-head'])}>
        <FormattedMessage {...messages.lastModified} />
      </div>
      <div className={gridStyle['header-item']}>
        <FormattedMessage {...messages.actions} />
      </div>
    </div>
  );
};

export default GridHeader;
